import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function GameScoreBug({ ariaLabel, className, isLiveGame, onActivate, score, }) {
    const resolvedClassName = `${className} game-score-bug${isLiveGame ? ` ${className}--live game-score-bug--live` : ""}`;
    const contents = (_jsxs(_Fragment, { children: [isLiveGame ? (_jsx("span", { "aria-hidden": "true", className: "live-score-dot" })) : null, score] }));
    if (onActivate) {
        return (_jsx("button", { "aria-label": ariaLabel ?? `Open game: ${score}`, className: resolvedClassName, onClick: onActivate, type: "button", children: contents }));
    }
    return _jsx("span", { className: resolvedClassName, children: contents });
}
